import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { isStaging } from 'helpers';
import { Back, Fail, Success } from 'pages/Market/PaymentResultPages';
import { Layout } from 'components/Layout';
import { AppWrapper } from './AppWrapper';
import { LoaderFixed } from 'components/Loaders';

const Quiz = lazy(() => import('pages/Quiz'));
const Search = lazy(() => import('pages/Search'));
const User = lazy(() => import('pages/User'));
const Achievements = lazy(() => import('pages/Achievements'));
const Operator = lazy(() => import('pages/Operator'));
const Market = lazy(() => import('pages/Market'));
const ChristmasEvent = lazy(() => import('pages/Events/ChristmasEvent'));
const Football24Event = lazy(() => import('pages/Events/Football24Event'));

const MarketApp = () => {
  return (
    <Suspense fallback={<LoaderFixed />}>
      <AppWrapper>
        <Routes>
          <Route path="/" element={<Layout hideProfileInfo={!isStaging()} />}>
            <Route path="*" element={<Navigate to="/" />} />
            <Route index element={<Search />} />
            <Route path="/user/:id" element={<User />} />
            <Route path="/user/:id/achievements" element={<Achievements />} />
            <Route path="/user/:id/preset/:operatorId" element={<Operator />} />
            {/* Christmas advent calendar. Unlock in winter */}
            {/* {isStaging() && (
              <Route path="/events/christmas" element={<ChristmasEvent />} />
            )} */}

            <Route path="/events/gunball2024" element={<Football24Event />} />
            {isStaging() && <Route path="/quiz/:id" element={<Quiz />} />}
            {isStaging() && <Route path="/market" element={<Market />} />}
          </Route>
          <Route path="/" element={<Layout withHeader={false} withFooter={false} />}>
            <Route path="/market/success" element={<Success />} />
            <Route path="/market/fail" element={<Fail />} />
            <Route path="/market/back" element={<Back />} />
          </Route>
        </Routes>
      </AppWrapper>
    </Suspense>
  );
};

export default MarketApp;
